/* eslint-disable react/no-multi-comp */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { FSBTable } from 'components/common/FSBTable';
import { isEmpty } from 'lodash';
import {
  activeAndInactivebidsColumns,
  childBidsColumns,
  defaultDeleteFilter,
  showSequenceNumber,
} from 'utils/constants';
import { Button } from 'reactstrap';
import { MdOutlineExpandLess, MdOutlineExpandMore } from 'react-icons/md';
import ErrorMessage from 'components/ErrorMessage';
import Loader from 'components/common/Loader';
import { toast } from 'react-toastify';
import {
  BID_OFFERS_SUBSCRIPTION_QUERY,
  LATEST_ALL_BIDS_QUERY,
  LATEST_ALL_BIDS_SUBSCRIPTION_QUERY,
} from 'utils/CommonGraphQL';
import { setBidDetails } from 'actions/bidDetailAction';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import NoDataFound from 'components/NoDataFound';

const ChildBids = ({ row }) => {
  const { allBids } = row.original;
  return (
    <FSBTable
      keyField="id"
      columns={childBidsColumns}
      data={allBids || []}
      totalCount={allBids?.length}
      pagePerSize={allBids?.length}
      // SubComponent={LastRow}// May use later
      search={false}
      pagination={false}
      isRowExpanded
      getRowCanExpand={() => true}
      showPagination={false}
    />
  );
};

const Bids = ({ id, status, bidType }) => {
  const dispatch = useDispatch();
  const todayDate = new Date();
  const date = moment(todayDate);
  const yesterdayDate = date.subtract(2, 'days').toDate();
  const dateAndTimeMilliseconds = yesterdayDate.valueOf();

  const [filters, setFilters] = useState({
    filter: [
      {
        key: bidType,
        value: id,
        type: 'INT',
        op: 'EQ',
      },
      {
        key: 'parentBid',
        value: '',
        type: 'NULL',
        op: 'IS_NULL',
      },
      {
        key: 'bidType',
        value: bidType.toUpperCase(),
        type: 'STRING',
        op: 'EQ',
      },

      {
        key: 'status',
        value: status,
        type: 'STRING',
        op: 'EQ',
      },
      {
        key: 'createdAt',
        value: dateAndTimeMilliseconds,
        type: 'DATE',
        op: 'GTE',
      },
      { ...defaultDeleteFilter },
    ],
    pageNo: 1,
    pageSize: 10,
  });

  const { data, loading, error, refetch, subscribeToMore } = useQuery(
    LATEST_ALL_BIDS_QUERY,
    {
      variables: { ...filters },
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
  );
  useEffect(() => {
    const allFilters = [...filters.filter];
    allFilters[0].value = id;
    refetch({
      ...filters,
      filter: [...allFilters],
    });
  }, [id]);

  const findIndexOfItem = (item) => {
    return activeAndInactivebidsColumns.findIndex(
      (itm) => itm.accessorKey === item,
    );
  };
  activeAndInactivebidsColumns[findIndexOfItem('SNo')].cell = ({
    cell,
    row,
  }) => {
    return (
      <>
        {row.getCanExpand() ? (
          <Button
            color="link"
            className="text-decoration-none p-0 text-active"
            type="button"
            {...{
              onClick: row.getToggleExpandedHandler(),
              style: { cursor: 'pointer' },
            }}
          >
            {row.getIsExpanded() ? (
              <MdOutlineExpandLess className="me-2" size={20} />
            ) : (
              <MdOutlineExpandMore className="me-2" size={20} />
            )}
          </Button>
        ) : null}
        {showSequenceNumber(cell, filters)}
      </>
    );
  };

  useEffect(() => {
    let currentId = '';
    const deletedObj = filters.filter.filter((val) => val.key !== 'isDeleted');
    const unsubscribe = subscribeToMore({
      document: LATEST_ALL_BIDS_SUBSCRIPTION_QUERY,
      variables: { ...filters, filter: deletedObj },
      updateQuery: (prev, { subscriptionData }) => {
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        if (subscriptionData.data?.allBids?.groupedBid)
          currentId =
            subscriptionData.data?.allBids?.groupedBid?.latestBid?.offer?.id;

        return subscriptionData.data;
      },
    });

    const unsubscribe1 = subscribeToMore({
      document: BID_OFFERS_SUBSCRIPTION_QUERY,
      variables: {
        ...filters,
        filter: [
          {
            key: 'entityName',
            joinAttributeName: 'trader',
            value: '',
            type: 'STRING',
            op: 'LIKE',
          },

          {
            key: 'parentBid',
            value: ' ',
            op: 'IS_NULL',
            type: 'NULL',
            setAttribute: 'bids',
          },
          {
            key: 'status',
            value: 'BID_IN_PROGRESS',
            type: 'STRING',
            setAttribute: 'bids',
            op: 'EQ',
          },
          {
            key: 'totalQty',
            value: 0,
            type: 'INT',
            op: 'GT',
          },
        ],
      },
      updateQuery: (prev, { subscriptionData }) => {
        if (subscriptionData.data?.bidOffers?.action === 'DELETED') {
          if (subscriptionData.data?.bidOffers?.offer?.id === currentId)
            toast.info(`Your Bid is Closed.`);
          dispatch(setBidDetails({ status: false, selectedBid: null }));
        }
      },
    });
    return () => {
      unsubscribe();
      unsubscribe1();
    };
  }, []);

  // method for use of subscribeToMore
  if (loading && !data?.allBids?.groupedBids) {
    return <Loader />;
  }
  if (error && !data?.allBids?.groupedBids)
    return <ErrorMessage error={error} />;
  if (!data?.allBids?.groupedBids)
    return (
      <div className="mt-3">
        <NoDataFound message="Bids not found" />
      </div>
    );

  const { totalCount, totalPages } = data?.allBids || {};
  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };

  return (
    <div className="expandable-table">
      {/* Common data table to show users list*/}
      <FSBTable
        data={data?.allBids?.groupedBids || []}
        columns={activeAndInactivebidsColumns}
        currentPageNo={filters.pageNo}
        pageSize={filters.pageSize}
        totalPages={totalPages || 0}
        totalCount={totalCount || 0}
        keyField="id"
        search={false}
        pagination={false}
        remote
        loading={loading}
        striped={false}
        hover={false}
        bordered={false}
        wrapperClass="table-responsive word-break"
        handlePageChange={handlePageChange}
        SubComponent={ChildBids}
        // defaultSorting={defaultSorting}

        isRowExpanded={false}
        getRowCanExpand={() => true}
      />
    </div>
  );
};

export default Bids;
